import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { MultiAutoSuggest } from './MultiAutoSuggest'

export class MultiCountrySelect extends PureComponent {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([''])]) ,
    onChange: PropTypes.func,
    countries: PropTypes.array,
    groups: PropTypes.array,
  }

  countryLabelProvider = ({type, name, iso3, continent, countries }) =>{
    switch(type){
      case 'countries':
        return `${name} (${iso3}-${continent})`
      case 'countryGroups':
      default:
        return (
          <span style={{fontWeight: 'bold'}}>{name}&nbsp;
            <span style={{fontWeight: 'normal', textStyle: 'italic'}}>
            ({countries.length} Countries)
          </span>
        </span>
        )
    }
  }

  countriesValueProvider = selected => {
    const selectedCountries = this.selectedCountriesById
    if(selected.type === 'countryGroups'){
      return selected.countries.filter(({id}) => !selectedCountries.get(id))
    }
    return [selected]
  }

  provideCountriesAndCountryGroups = (query, callback, error) =>{
    const [countries, groups] = this.filterSeenCountriesAndGroups(this.props.countries, this.props.groups, query)
    const results = []

    if (groups.length)
      results.push({title: 'Groups', suggestions: groups })

    if(countries.length)
      results.push({title: 'Countries', suggestions: countries})

    callback(results)
  }

  filterQuery = (collection, query) =>
    collection.filter(i => i.name.toLowerCase().startsWith(query.toLowerCase()) ||
                           i.iso3.toLowerCase().startsWith(query.toLowerCase()) ||
                           i.continent.toLowerCase().startsWith(query.toLowerCase()))

  filterSeenCountriesAndGroups = (countries, groups, query) => {
    const selectedCountries = this.selectedCountriesById
    const countryResults = this.filterQuery(countries, query).filter(({id}) => !selectedCountries.get(id))
    const groupResults   = this.filterQuery(groups, query).filter(({countries}) =>
      countries.find(({id}) => !selectedCountries.get(id))
    )
    return [countryResults, groupResults]
  }

  get selectedCountriesById(){
    return new Map((this.props.value || []).map(country => [country.id, country]))
  }

  render = () =>
    <MultiAutoSuggest values={this.props.value || []}
                      onChange={this.props.onChange}
                      labelProvider={this.countryLabelProvider}
                      multiSection={true}
                      valueProvider={this.countriesValueProvider}
                      fullWidth
                      label='Countries'
                      onSuggestionsFetchRequested={this.provideCountriesAndCountryGroups}
    />
}